// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1iZDT","left":"InfoRow_left__2o_rf"};